import type { FC, ReactNode } from "preact/compat";
import { useRef } from "preact/hooks";
import classnames from 'classnames'
import "./index.scss";

export type ComboboxGroupedButtonsProps = {
  children: ReactNode;
  new_styles?: boolean;
  tabbed_filters?: boolean;
};

export const ComboboxGroupedButtons: FC<ComboboxGroupedButtonsProps> = ({
  children,
  new_styles,
  tabbed_filters,
}) => {
  const buttonGroupRef = useRef<HTMLDivElement | null>(null);
  return (
    <div
      className={classnames('ComboboxGroupedButtons', {
        'ComboboxGroupedButtons--new-styles': new_styles,
        'ComboboxGroupedButtons--tabbed-filters': tabbed_filters,
      })}
      role="group"
      ref={buttonGroupRef}
    >
      {children}
    </div>
  );
};
